import { createContext, useContext, type RefObject } from "react";

export type PillSelectorContextValue = {
  value: string | string[] | null;
  multi?: boolean;
  onToggle: (value: string) => void;
  disabled?: boolean;
  containerRef: RefObject<HTMLDivElement | null>;
  onKeyDown: (e: React.KeyboardEvent, optionValue: string) => void;
};

export const PillSelectorContext = createContext<PillSelectorContextValue | null>(null);

export function usePillSelectorContext() {
  const context = useContext(PillSelectorContext);
  if (!context) {
    throw new Error("PillSelector.Option must be used within PillSelector.Root");
  }
  return context;
}
